import { render, staticRenderFns } from "./ServiceConfigUserEdit.vue?vue&type=template&id=1b9f061f"
import script from "./ServiceConfigUserEdit.vue?vue&type=script&lang=js"
export * from "./ServiceConfigUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports